class BreadcrumbModel {
  constructor(values = {}) {
    this.breadcrumb_url = values?.breadcrumb_url || ''
    this.breadcrumb_label = values?.breadcrumb_label || ''
  }
}

export default BreadcrumbModel
